<template>
  <div id="home">
    <div id="home-main">
      <img id="title" :src="require('../assets/images/title-'+ $i18n.locale +'.png')" />
      <img id="title2" :src="require('../assets/images/title2-'+ $i18n.locale +'.png')" />
      <img id="play" src="../assets/images/play.png" @click.stop="toggleHomeVideo()"/>
      <div id="group">
        <a target="_blank" href="https://store.steampowered.com/app/2273430"><img id="download" :src="require('../assets/images/steam-'+ $i18n.locale +'.png')" /></a>
        <table id="url-btn">
          <tr>
            <td>
              <a target="_blank" href="https://space.bilibili.com/1663803541"><img class="btns" src="../assets/images/bilibili-home.png" /></a>
            </td>
            <td>
              <a target="_blank" href="https://www.taptap.cn/app/233514"><img class="btns" src="../assets/images/taptap-home.png" /></a>
            </td>
          </tr>
          <tr>
            <td>
              <!-- <a target="_blank" href=""><img class="btns" src="../assets/images/PS.png" /></a> -->
              <img class="btns" src="../assets/images/PS.png" />
            </td>
            <td>
              <img class="btns" src="../assets/images/switch.png" />
            </td>
          </tr>
        </table>
        <img id="notice" src="../assets/images/notice.png" />
      </div>
    </div>
    <img id="home-cover" src="../assets/images/home-cover.png" />
      <video ref="homeVideo" id="home-video" src="../assets/video/top-video.mp4" muted autoplay loop>
        {{ $t("role.playerWarning") }}
      </video>
  </div>
</template>

<script>
export default {
  data(){
    return{
      homeVideo: true,
    }
  },
  methods:{
    toggleHomeVideo(){
      this.homeVideo = !this.homeVideo
      if(this.homeVideo){
        this.$refs.homeVideo.play()
        this.$refs.homeVideo.muted = false 
      }else{
        this.$refs.homeVideo.pause()
      }
    }
  }
}
</script>

<style scoped lang="scss">
#home-main {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 99;
}
#title {
  width: 1014px;
  height: 188px;
  position: absolute;
  left: 50%;
  margin-left: -507px;
  margin-top: 220px;
}
#title2 {
  width: 1145px;
  height: 43px;
  position: absolute;
  left: 50%;
  margin-left: -573px;
  margin-top: 398px;
}
#play {
  width: 480px;
  height: 104px;
  position: absolute;
  left: 50%;
  margin-left: -240px;
  margin-top: 455px;
  cursor: pointer;
}
#group{
  position: absolute;
  left: 50%;
  margin-left: -354px;
  margin-top: 620px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#download{
  width: 327px;
  height: 119px;
  display: inline-block;
  cursor: pointer;
}
#url-btn{
  display: inline-block;
  td{
    line-height: 0;
  }
  margin: 0 10px 0 3px;
}
.btns {
  width: 147px;
  height: 54px;
  cursor: pointer;
}
#notice {
  width: 84px;
  height: 110px;
  display: inline-block;
  cursor: pointer;
}
#home-cover{
  width: 1920px;
  height: 1080px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
}
#home-video{
  width: 1920px;
  height: 1080px;
  position: fixed;
  left: 0;
  top: -10px;
}
</style>
